<template>
  <div>
    <el-form-item label="文本来源">
      <el-select :value="source" aria-label="文本来源" @input="set('textSource', $event)">
        <el-option label="原有文本／数据配置" value="data" />
        <el-option label="当前页面产品名称" value="pageProduct" />
        <el-option label="当前页面设备名称" value="pageDevice" />
        <el-option label="当前页面设备编号" value="pageDeviceId" />
      </el-select>
    </el-form-item>
    <template v-if="source !== 'data'">
      <el-form-item label="数据来源"><el-select :value="main.activeOption.contextDataSource === 'static' ? 'static' : 'platform'" aria-label="名称文本数据来源" @input="set('contextDataSource', $event)"><el-option label="平台数据" value="platform" /><el-option label="静态演示" value="static" /></el-select></el-form-item>
      <el-form-item label="前缀文字"><el-input :value="main.activeOption.textPrefix || ''" maxlength="256" :label="settings.label + '前缀'" placeholder="例如：当前：" @input="set('textPrefix', $event)" /></el-form-item>
      <el-form-item label="后缀文字"><el-input :value="main.activeOption.textSuffix || ''" maxlength="256" :label="settings.label + '后缀'" placeholder="例如：总览" @input="set('textSuffix', $event)" /></el-form-item>
      <el-form-item :label="settings.identifier ? '编辑示例编号' : '编辑示例名称'"><el-input :value="example" maxlength="256" :label="'编辑示例' + settings.label" @input="set(settings.exampleKey, $event)" /></el-form-item>
      <el-form-item label="未传参占位"><el-input :value="empty" maxlength="256" :label="'未传入' + (settings.device ? '设备' : '产品') + '时的占位文字'" @input="set(settings.emptyKey, $event)" /></el-form-item>
      <p v-if="main.activeOption.contextDataSource === 'static'" class="page-product-text-help">演示模式显示已保存的名称示例或案例名称映射。接入真实设备后切换为平台数据；前缀和后缀保持。</p>
      <p v-else class="page-product-text-help">{{ settings.identifier ? '设备编号直接显示页面传入的 deviceId。' : '按上级页面传入的 ' + settings.contextKey + ' 读取有权访问的' + settings.label + '。' }}显示为“前缀＋{{ settings.label }}＋后缀”。示例仅用于编辑和模板，不用于正式预览／运行；未传参时只显示占位，不出现重试按钮。</p>
    </template>
  </div>
</template>
<script>
import { pageTextSettings } from '@/runtime/page-context-text-model'
export default {
  inject: ['main'],
  computed: {
    source () { return pageTextSettings(this.main.activeOption).source },
    settings () { return pageTextSettings(this.main.activeOption) },
    example () { return pageTextSettings(this.main.activeOption).example },
    empty () { return pageTextSettings(this.main.activeOption).empty }
  },
  methods: { set (key, value) { if (key === 'textSource' && value !== 'data' && this.main.activeObj && Number(this.main.activeObj.dataType) === 6) this.$set(this.main.activeObj, 'dataType', 0); this.$set(this.main.activeOption, key, value) } }
}
</script>
<style scoped>
.el-select { width: 100%; }
.page-product-text-help { font-size: 12px; line-height: 1.7; color: var(--editor-muted, #97b8c8); margin: 8px 0 12px; overflow-wrap: anywhere; }
</style>
